var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5243 7.1981C21.5338 7.40908 21.5386 7.62105 21.5386 7.83396C21.5386 14.3281 16.5951 21.8161 7.557 21.8161C4.78158 21.8161 2.19816 21.0025 0.0234375 19.6081C0.408375 19.6537 0.799031 19.677 1.19587 19.677C3.49842 19.677 5.61703 18.8914 7.29942 17.573C5.14847 17.5336 3.33398 16.1127 2.70858 14.1603C3.00895 14.2179 3.31645 14.2488 3.63342 14.2488C4.08108 14.2488 4.51542 14.1884 4.92797 14.0763C2.68008 13.6247 0.985781 11.6387 0.985781 9.25774C0.985781 9.23683 0.985781 9.21639 0.986297 9.19596C1.64878 9.56379 2.40633 9.7848 3.2123 9.81044C1.89352 8.92938 1.02619 7.42521 1.02619 5.72003C1.02619 4.81947 1.26806 3.97544 1.69148 3.24972C4.11525 6.22282 7.73559 8.17891 11.8199 8.38422C11.7362 8.02446 11.6925 7.6495 11.6925 7.2641C11.6925 4.55046 13.8928 2.3501 16.6065 2.3501C18.0208 2.3501 19.2973 2.947 20.1936 3.90175C21.3133 3.68172 22.3645 3.27255 23.314 2.70935C22.9471 3.85708 22.1686 4.81989 21.1536 5.42819C22.1477 5.30936 23.0954 5.04518 23.9765 4.65452C23.3178 5.63974 22.4843 6.50514 21.5243 7.1981Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.fff388e33aeafe734d95ce7cce3f1501.svg";
export { ForwardRef as ReactComponent };